import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 1,
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: { src: `${config.ASSETS_URL}/01/20/principle/cylindrical-full-m-2-n0-p5.png` },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: { src: `${config.ASSETS_URL}/01/20/principle/cylindrical-cut-m-2-n0-p5.png` },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
